<script>
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellNumInjectionsPerTech',
    extends: TableCellBase,
    computed: {
      actualValueRaw() {
        return this.round(this.getRatio(this.monthObj['num_injections'], this.monthObj['num_techs']), 2);
      },
    },
  };
</script>
